import { boAPI } from '../../constants/api';
import fetchApi from '../../services/fetch';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  data: {},
};

export const zendesk = {
  state: { ...initialState },
  reducers: {
    updateZendeskData(state, payload) {
      return {
        ...state,
        data: { ...state.data, ...payload },
      };
    },
    clearData() {
      return { ...initialState };
    },
  },
  effects: (dispatch) => {
    return {
      async createZendesk({ ...params }) {
        dispatch.apiStatus.setProcessing(true);
        const reqPayload = params;
        if (['development', 'staging'].includes(process.env['REACT_APP_ENVIRONMENT']?.toLowerCase())) {
          reqPayload.ticket.tags.push('qa_home_activator');
        }
        return fetchApi({
          method: 'POST',
          url: boAPI.zendeskCreate,
          data: { ...reqPayload },
        })
          .then(() => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true });
          })
          .catch((error) => {
            dispatch.apiStatus.setRequestFailed({ ...error });
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(error, ACTIVATION, `Zendesk`, boAPI.zendeskCreate, 'Zendesk API'),
            });
            track(MESSAGE_DISPLAYED, { ...generateMessageDisplayedSegment(error, ACTIVATION, 'Zendesk API') });
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
